import { takeLatest } from 'redux-saga/effects';
import {
  ABORT_UPLOAD,
  UPLOAD_FORM_CONFIG_REQUEST,
  UPLOAD_INIT_VIDEO_OBJECT_REQUEST,
  UPLOAD_PUBLISH_REQUEST,
} from './actions';

import {
  abortUploadEffect,
  publishVideoRequestEffect,
  uploadFormConfigRequestEffect,
  uploadVideoRequestEffect,
} from './effects';

export const uploadPageSaga = function* () {
  yield takeLatest(UPLOAD_INIT_VIDEO_OBJECT_REQUEST, uploadVideoRequestEffect);
  yield takeLatest(ABORT_UPLOAD, abortUploadEffect);
  yield takeLatest(UPLOAD_PUBLISH_REQUEST, publishVideoRequestEffect);
  yield takeLatest(UPLOAD_FORM_CONFIG_REQUEST, uploadFormConfigRequestEffect);
};
